import React, { PureComponent } from 'react';
import styles from '../styles/style.module.css';

import sliderNext from 'appSrc/assets/img/right-chev-purple.svg';

export default class RightControl extends PureComponent {
    render() {
        const { style, onClick, className, extendedClass } = this.props;
        var disabled = className.includes( 'slick-disabled' );
        return (
            <div className={ `${ styles.rightControl } ${ extendedClass }` }
            style={ { ...style, display: ( disabled ? 'none' : 'block' ) } }
            onClick={ onClick }>
                <img src={ sliderNext } />
            </div>
        );
    }
}
RightControl.defaultProps = {
    className: '',
    extendedClass: '',
};
